export class PointExpiryRuleModel {
    id : Number;
    rule_name: String;
    conditional_operator : string;
    expiry_point : number;
    status : any;
    start_date : string;
    end_date : string;
    startDate: any;
    endDate:any;
    channel_name : string;
    channel_id : number;
    created_date : string;
    updated_date : string;
    region_id : number;
    region_name : string;
    state_code : number;
    state_name: string;
    state_year : string;
    rule_point : number;
    statusString: string;
    exipry_date : string;
    expiryDate:any;
  }